module.exports = __webpack_public_path__ + "static/media/IMG_1270.d91021b2.jpg";